import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DASHBOARD } from '../../constant';

type InsightsArgs = {
  studyTypeYear?: number;
  referrerRange?: 'day' | 'month' | 'year';
  referrerAnchor?: string;
  overdueSort?: 'longest' | 'recent';
  /** Super Admin payload only: reporting period. `month` accepts 1–12 or 'all'. */
  year?: number;
  month?: number | 'all';
  /** Explicit range; when both are set the server reports on it instead of month/year. */
  from?: string;
  to?: string;
} | void;

/** Role-aware dashboard insights — KPIs, trend, breakdowns, queues. Params used by the Admin/Receptionist payloads. */
export const getInsights = createAsyncThunk(
  'dashboard/insights',
  async (arg: InsightsArgs, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (arg?.studyTypeYear != null) {
        params.append('studyTypeYear', String(arg.studyTypeYear));
      }
      if (arg?.referrerRange) {
        params.append('referrerRange', arg.referrerRange);
      }
      if (arg?.referrerAnchor) {
        params.append('referrerAnchor', arg.referrerAnchor);
      }
      if (arg?.overdueSort) {
        params.append('overdueSort', arg.overdueSort);
      }
      if (arg?.year != null) {
        params.append('year', String(arg.year));
      }
      if (arg?.month != null) {
        params.append('month', String(arg.month));
      }
      if (arg?.from && arg?.to) {
        params.append('from', arg.from);
        params.append('to', arg.to);
      }
      const qs = params.toString();
      const res = await fetch(qs ? `${DASHBOARD.GET_INSIGHTS}?${qs}` : DASHBOARD.GET_INSIGHTS, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to fetch insights');
      }
      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
